import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fetch } from '@ngrx/router-store/data-persistence';
import { ShopService } from '@us/web/shop/data-access';
import { map } from 'rxjs';
import { ShopsActions } from './shops.actions';

@Injectable()
export class ShopsEffects {
    private readonly actions$ = inject(Actions);
    // private readonly store = inject(Store);
    private readonly shopService = inject(ShopService);

    loadShops$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ShopsActions.loadShops),
            // concatLatestFrom(() => this.store.select(selectCurrentLocation)),
            // switchMap(([, location]) =>
            //     this.shopService.getListShops({ lat: location?.lat, lng: location?.lng }).pipe(
            //         map(shops => ShopsActions.loadShopsSuccess({ shops })),
            //         catchError(() => EMPTY)
            //     )
            // )
            fetch({
                run: location =>
                    this.shopService
                        .getListShops({ lat: location?.lat, lng: location?.lng })
                        .pipe(map(shops => ShopsActions.loadShopsSuccess({ shops }))),
                onError: (action, error) => {
                    console.error('Error', error);
                    return ShopsActions.loadShopsFailure({ error });
                }
            })
        );
    });
}
